import Axios from "axios";
// import store from "@/store";

Axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
Axios.defaults.headers.common.Accept = "application/json";
// Axios.interceptors.response.use(
//     response => response,
//     error => {
//         if (error?.response?.status === 401) {
//             store.dispatch("auth/logout");
//         }

//         return Promise.reject(error);
//     }
// );
